import { render, staticRenderFns } from "./sidepane.vue?vue&type=template&id=cd908b42&scoped=true&lang=pug"
import script from "./sidepane.vue?vue&type=script&lang=js"
export * from "./sidepane.vue?vue&type=script&lang=js"
import style0 from "./sidepane.vue?vue&type=style&index=0&id=cd908b42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd908b42",
  null
  
)

export default component.exports